const isDev = import.meta.env.DEV;

const logger = {
  info: (...args) => {
    if (isDev) {
      console.info(...args);
    }
  },
  warn: (...args) => {
    if (isDev) {
      console.warn(...args);
    }
  },
  error: (...args) => {
    console.error(...args);
  },
};

export default logger;